/** @jsxRuntime classic */
/** @jsx jsx */
import React, { ReactElement } from 'react';
import { ButtonIcon } from '../../atoms/icons/favoriteIcons';
import { jsx } from '@emotion/core';
import { ButtonContainer, CustomButton, IconContainer, ButtonWrap } from './FavoriteButtonStyles';
import StarFillIcon from '../icons/StarFillIcon';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';

const FavoriteButtonV2 = (props: any): ReactElement => {
  const { favorited, ...rest } = props;
  const { isMobile } = useMediaBreakpoints();

  return (
    <ButtonContainer data-test-id="btn-container" aria-label={favorited ? 'Unfavorite' : 'Favorite'}>
      <CustomButton
        data-test-id={favorited ? 'remove-fav-btn' : 'add-fav-btn'}
        id="fav-btn"
        title={favorited ? 'Remove from My Favorites' : 'Add to My Favorite'}
        className="favorite-button"
        isFavorited={favorited}
        style={{ margin: 0 }}
        {...rest}
        aria-label={favorited ? 'Unfavorite' : 'Favorite'}
      >
        <IconContainer>
          {favorited ? (
            <StarFillIcon height={isMobile ? 28.21 : 56} width={isMobile ? 28.21 : 55} />
          ) : (
            <ButtonIcon fill={favorited ? '' : ''} />
          )}
        </IconContainer>
      </CustomButton>
      <label>{favorited ? 'Unfavorite' : 'Favorite'}</label>
    </ButtonContainer>
  );
};

export const HighlightFavoriteButton = (props: any): ReactElement => {
  const { favorited, ...rest } = props;
  // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
  const favoriteButtonStyle = favorited ? { ...style.default, ...style.favorited } : style.default;

  return (
    <ButtonWrap customStyle={favoriteButtonStyle} {...rest}>
      <IconContainer>
        <ButtonIcon fill={favorited ? 'rgb(255, 255, 255)' : 'rgb(255, 175, 0)'} />
      </IconContainer>
    </ButtonWrap>
  );
};

export default FavoriteButtonV2;
